import api from 'services/api';

export const projectService = {
  // ========================================
  // Project CRUD Operations
  // ========================================

  // Get all projects with filters
  getProjects: async (params = {}) => {
    const response = await api.get('/projects', { params });
    return response.data;
  },

  // Get project statistics
  getStatistics: async () => {
    const response = await api.get('/projects/statistics');
    return response.data;
  },

  // Get single project
  getProject: async (id) => {
    const response = await api.get(`/projects/${id}`);
    return response.data;
  },

  // Create new project (admin only)
  createProject: async (data) => {
    const response = await api.post('/projects', data);
    return response.data;
  },

  // Update project (admin only)
  updateProject: async (id, data) => {
    const response = await api.put(`/projects/${id}`, data);
    return response.data;
  },

  // Delete project (admin only)
  deleteProject: async (id) => {
    const response = await api.delete(`/projects/${id}`);
    return response.data;
  },

  // ========================================
  // Vendor Assignment Operations (admin only)
  // ========================================

  // Assign vendor to project
  assignVendor: async (projectId, data) => {
    const response = await api.post(`/projects/${projectId}/assign-vendor`, data);
    return response.data;
  },

  // Update vendor assignment
  updateAssignment: async (projectId, assignmentId, data) => {
    const response = await api.put(`/projects/${projectId}/assignments/${assignmentId}`, data);
    return response.data;
  },

  // Remove vendor from project
  removeVendor: async (projectId, assignmentId) => {
    const response = await api.delete(`/projects/${projectId}/assignments/${assignmentId}`);
    return response.data;
  },

  // ========================================
  // Clients & Vendors (Admin routes)
  // ========================================

  getClients: async (params = {}) => {
    const response = await api.get('/admin/clients', { params });
    return response.data;
  },

  getVendors: async (params = {}) => {
    const response = await api.get('/admin/vendors', { params });
    return response.data;
  },

  // Get subcontractors for a specific vendor
  getVendorSubcontractors: async (vendorId) => {
    const response = await api.get(`/projects/vendors/${vendorId}/subcontractors`);
    return response.data;
  }
};

export default projectService;
